import { Presenter } from '~/framework/Presenter';
import { User } from '~/state/mainAppState';

export interface PresentableTenantInfo {
  firstName: string;
  lastName: string;
  chatId: string;
  email?: string;
  phoneNumber?: string;
  language?: string;
  id?: string;
  name?: string;
}

export class TenantInfoPresenter extends Presenter<PresentableTenantInfo> {
  protected createModel = (state: User): PresentableTenantInfo => {
    return {
      firstName: state.info?.firstName || '',
      lastName: state.info?.lastName || '',
      chatId: state.info?.chatId || '',
      email: state.info?.email || '',
      phoneNumber: state.info?.phoneNumber || '',
      language: state.info?.language || '',
      id: state.info?.id || '',
      name: `${state.info?.firstName} ${state.info?.lastName ?? ''}`.trim(),
    };
  };
}
